import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import { LoadingState } from '../states/StateViews';
import { canAccessAdmin } from '../../lib/adminAccess';

export function RequireAdminLayout() {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <LoadingState label="Checking admin access…" />;
  }

  if (status === 'guest') {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" state={{ from }} replace />;
  }

  if (!canAccessAdmin(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
